export enum JobOp {
    EQ = 'EQ', // Equal
    NE = 'NE', // Not equal
    LT = 'LT', // Less than
    LE = 'LE', // Less than or equal to
    GT = 'GT', // Greater than
    GE = 'GE', // Greater than or equal to
    CN = 'CN', // Contains
    SW = 'SW', // Starts with
    EW = 'EW', // Ends with
    IN = 'IN', // In (for arrays)
    NI = 'NI' // Not in (for arrays)
}
